import { defineComponent as t, inject as c, h as d } from "vue";
import { configProviderInjectionKey as v } from "./highrise690.mjs";
import m from "./highrise1450.mjs";
function s(r, l) {
  const u = t({
    render() {
      return l();
    }
  });
  return t({
    name: m(r),
    setup() {
      var e;
      const n = (e = c(v, null)) === null || e === void 0 ? void 0 : e.mergedIconsRef;
      return () => {
        var o;
        const i = (o = n == null ? void 0 : n.value) === null || o === void 0 ? void 0 : o[r];
        return i ? i() : d(u, null);
      };
    }
  });
}
export {
  s as replaceable
};
